import { Grid } from "@mui/material";
import React from "react";

const DashboardList = (props) => {
    return(
        <Grid
            container
            xs={12}
            className="px-0 py-1"
        >
            <Grid
                xs={6}
                className="text-left"
            >
                <h6>
                    {props.listTitle}
                </h6>
            </Grid>
            <Grid
                xs={6}
                className="text-right"
            >
                <h6>
                    {props.listValue}
                </h6>
            </Grid>
        </Grid>
    )
}
export default DashboardList;